import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { CostCalculatorComponent } from './cost-calculator.component';
import { MfgappsEventService } from 'src/app/services/mfgapps-event.service';

@Component({
  selector: 'app-dt-calculator-page',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, MatButtonModule,
    MatProgressSpinnerModule, CostCalculatorComponent],
  templateUrl: './dt-calculator-page.component.html',
  styleUrl: './dt-calculator-page.component.scss'
})
export class DtCalculatorPageComponent implements OnInit {
  selectionForm!: FormGroup;
  companyList: any[] = [];
  currentCompany: any;
  currentPlant: any;
  calculatorPayload: any;
  loader = { isLoading: true, message: 'Loading Corporate Hierarchy...' };
  errorMessage = '';

  constructor(private readonly formBuilder: FormBuilder, private readonly eventService: MfgappsEventService) {}

  ngOnInit() {
    this.selectionForm = this.formBuilder.group({
      company_id: ['', Validators.required],
      plant_id: ['', Validators.required],
      shop_id: ['', Validators.required]
    });
    this.loadCorporateHierarchy();
  }

  async loadCorporateHierarchy() {
    try {
      this.companyList = await this.eventService.getCorporateHierarchy();
      this.loader.isLoading = false;
      this.loader.message = '';
    }
    catch (error) {
      console.info(error);
      this.loader.isLoading = false;
      this.loader.message = '';
      this.errorMessage = 'Error occurred while loading Corporate Hierarchy. Please try again.';
      this.eventService.showSnackBar(this.errorMessage, 'error');
    }
  }

  onCompanyChange(companyId: number) {
    this.currentCompany = this.companyList.find(company => company.company_id === companyId);
    this.currentPlant = null;
    this.selectionForm.patchValue({ plant_id: '', shop_id: '' });
    this.calculatorPayload = null;
  }

  onPlantChange(plantId: number) {
    this.currentPlant = this.currentCompany?.plantList.find(plant => plant.plant_id === plantId);
    this.selectionForm.patchValue({ shop_id: '' });
    this.calculatorPayload = null;
  }

  launchCalculator() {
    this.selectionForm.markAllAsTouched();
    if (this.selectionForm.invalid) {
      this.eventService.showSnackBar('Please select Company, Plant and Shop', 'warn');
      return;
    }

    const formValues = this.selectionForm.getRawValue();
    const payload = {
      title: 'Downtime Cost Calculator',
      entryDetails: {
        date: new Date(),
        company_id: formValues.company_id,
        plant_id: formValues.plant_id,
        shop_id: formValues.shop_id
      },
      costCalculationSteps: null
    };

    // Recreate the calculator instance so it fully re-initializes for a new selection.
    this.calculatorPayload = null;
    Promise.resolve().then(() => {
      this.calculatorPayload = payload;
    });
  }
}